import { render, staticRenderFns } from "./SearchResultFacetsCollections.vue?vue&type=template&id=684e693e"
import script from "./SearchResultFacetsCollections.vue?vue&type=script&lang=js"
export * from "./SearchResultFacetsCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports